import { InputV2, useDisclosure } from '@withjoy/joykit';
import React, { useMemo } from 'react';
import TimePickerDialog from './TimePickerDialog';

const TimePicker: React.FC<{
  placeholder?: string;
  /** Value of the field */
  value: string;
  /** Name of the field */
  name: string;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error?: any;

  isInvalid?: boolean;
  /** Change event handler */
  onChange?: (value: string) => void;
  /** To display the time in 24hr format */
  displayIn24HourFormat?: boolean;
}> = ({ onChange, placeholder, value, displayIn24HourFormat = false, ...restProps }) => {
  const {
    isOpen: isTimePickerOpen,
    onOpen: openTimePicker,
    onClose: closeTimePicker,
  } = useDisclosure({
    defaultIsOpen: false,
  });

  const { defaultAmPm, defaultHours, defaultMinutes } = useMemo(() => {
    const arrHoursMinutes = value.split(':');
    const hours = +arrHoursMinutes[0];
    const minutes = +arrHoursMinutes[1];

    if (isNaN(hours) || isNaN(minutes)) {
      return {
        defaultAmPm: 'PM',
        defaultHours: '',
        defaultMinutes: '',
      };
    }

    let hourChanged = hours;

    if (hours === 0) {
      hourChanged = 12;
    } else if (hours > 12) {
      hourChanged = hours - 12;
    }

    return {
      defaultAmPm: hours >= 12 ? 'PM' : 'AM',
      defaultHours: hourChanged.toString(),
      defaultMinutes: minutes.toString(),
    };
  }, [value]);

  const formatValue = (value: string) => {
    if (!displayIn24HourFormat) {
      return defaultHours && defaultMinutes ? `${defaultHours.padStart(2, '0')}:${defaultMinutes.padStart(2, '0')} ${defaultAmPm}` : value;
    }
    return value;
  };

  return (
    <>
      <InputV2
        overrides={{
          Root: {
            props: {
              _hover: {
                borderColor: 'mono14',
              },
            },
          },
        }}
        {...restProps}
        isReadOnly={true}
        onClick={() => {
          openTimePicker();
        }}
        value={formatValue(value)}
        placeholder={placeholder}
      />
      <TimePickerDialog
        isOpen={isTimePickerOpen}
        onSave={timeString => {
          closeTimePicker();
          onChange?.(timeString);
        }}
        defaultAmPm={defaultAmPm}
        defaultHours={defaultHours}
        defaultMinutes={defaultMinutes}
        onClose={closeTimePicker}
      />
    </>
  );
};

export default TimePicker;
